// Firebase configuration
// IMPORTANT: Fill in values from your Firebase Console:
// Project Settings → General → Your apps → Web app config.
// For production, prefer environment variables (REACT_APP_FIREBASE_*) in .env.

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'YOUR_API_KEY',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'brainaxis-website.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'brainaxis-website',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'brainaxis-website.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || 'YOUR_SENDER_ID',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || 'YOUR_APP_ID',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
